import { defineStore } from 'pinia'
import Api from '../api/Api'

export const useEmbedMediaStore = defineStore('embedMedia', {
  state: () => ({
    embedLinks: [],
    embedMediaInfo: {},
  }),
  getters: {
    getEmbedLinks: function(state) {
      return state.embedLinks;
    },
    getEmbedlinkInfo: function(state) {
      return state.embedMediaInfo;
    },
  },
  actions: {
    refreshEmbedLinks: async function(podID) {
      const response = await Api.embedmedia.getEmbedLinks(podID);
      this.embedLinks = response.data;
    },

    createEmbedLink: async function(payload) {
      const response = await Api.embedmedia.createEmbedLink(payload);
      return response.data;
    },

    deleteEmbedLink: async function (payload) {
      const { linkId, podId } = payload;
      const response = await Api.embedmedia.deleteEmbedLink(podId, linkId);
      return response.data;
    },

    // External call
    refreshEmbedlinkInfo: async function(code) {
      const response = await Api.embedmedia.getEmbedlinkInfo(code);
      this.embedMediaInfo = response.data;
      return response.data;
    },
  }
});
